import Grid from '@material-ui/core/Grid';
import { memo, ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import { IOption } from '~/types';
import Checkbox from '~/ui/components/inputs/Checkbox';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';

interface IProps {
  clientNoShow: boolean;
  noShowReasons: IOption[];
  isEdit?: boolean;
}

const ClientNoShowFields = ({ clientNoShow, noShowReasons, isEdit }: IProps): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container item sm={9}>
      <Grid item sm={12}>
        <Checkbox
          control={control}
          errors={errors}
          name="clientNoShow"
          label="Client No Show"
          disabled={!isEdit}
        />
      </Grid>
      {clientNoShow && (
        <Grid item sm={12}>
          <Select
            control={control}
            errors={errors}
            name="noShowReason"
            label="No Show Reasons"
            options={noShowReasons}
            hideSelectedOptions={false}
            openMenuOnFocus
          />
        </Grid>
      )}
    </Grid>
  );
};

export default memo(ClientNoShowFields);
